import { Controller } from "@hotwired/stimulus";
import { applyStoredAiAssistantWidth } from "../utils/ai_assistant_width_sync";

const STORAGE_KEY = "depozen:ai-assistant-open";

export default class extends Controller {
  static targets = ["panel", "toggle", "resizeHandle"];

  static values = {
    openLabel: String,
    closeLabel: String,
  };

  connect() {
    applyStoredAiAssistantWidth();
    // Fermé à chaque arrivée sur l’étape (ex. Contenu) ; l’utilisateur rouvre via la baguette.
    this.open = false;
    this.syncUi();
  }

  disconnect() {
    document.documentElement.classList.remove("ai-assistant-open");
  }

  toggle() {
    this.open = !this.open;

    if (this.hasToggleTarget) {
      this.toggleTarget.classList.add("ai-assistant-shell__toggle--pulse");
      window.setTimeout(() => {
        this.toggleTarget?.classList.remove("ai-assistant-shell__toggle--pulse");
      }, 320);
    }

    this.syncUi();
  }

  close() {
    this.open = false;
    this.syncUi();
  }

  syncUi() {
    localStorage.setItem(STORAGE_KEY, this.open ? "1" : "0");
    this.element.dataset.aiAssistantLayout = this.open ? "opened" : "closed";
    document.documentElement.classList.toggle("ai-assistant-open", this.open);

    if (this.hasPanelTarget) {
      this.panelTarget.classList.toggle("d-none", !this.open);
      this.panelTarget.classList.toggle("d-flex", this.open);
      this.panelTarget.classList.toggle("flex-column", this.open);

      if (this.open) {
        this.panelTarget.classList.remove("ai-assistant-panel--animate-in");
        void this.panelTarget.offsetWidth;
        this.panelTarget.classList.add("ai-assistant-panel--animate-in");
      } else {
        this.panelTarget.classList.remove("ai-assistant-panel--animate-in");
      }
    }

    if (this.hasResizeHandleTarget) {
      this.resizeHandleTarget.classList.toggle("d-none", !this.open);
      // d-lg-block overrides d-none at the lg breakpoint; keep them in sync.
      this.resizeHandleTarget.classList.toggle("d-lg-block", this.open);
    }

    if (this.hasToggleTarget) {
      const label = this.open ? this.closeLabelValue : this.openLabelValue;
      this.toggleTarget.setAttribute("aria-label", label);
      this.toggleTarget.setAttribute("aria-expanded", this.open ? "true" : "false");
      this.toggleTarget.classList.toggle("ai-assistant-shell__toggle--opened", this.open);
    }
  }
}
